import Vue from 'vue'
import {
  fetchProjects,
  fetchProject,
  removeProject
} from '../../api'

const state = {
  all: [],
  details: {}
}

const getters = {}

const actions = {
  getProjects ({ commit }, { accountId }) {
    fetchProjects(accountId).then(projects => {
      commit('setProjects', projects)
    })
  },
  getProject ({ commit }, { id }) {
    fetchProject(id).then(project => {
      commit('setProject', { id, project })
    })
  },
  delProject ({ commit }, { id }) {
    removeProject(id).then(() => {
      commit('delProject', { id })
    })
  }
}

const mutations = {
  setProjects (state, projects) {
    state.all = projects
  },
  setProject (state, { id, project }) {
    Vue.set(state.details, id, project)
  },
  delProject (state, { id }) {
    const index = state.all.map(o => o.id).indexOf(id)
    Vue.delete(state.all, index)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
